import { combineReducers } from "redux";
import { connectRouter } from "connected-react-router";

/*--------------------------REDUCERS------------------------------------------*/
import authReducer from "./authReducer";
import chatReducer from "../slices/chat";
import conversationReducer from "../slices/conversation";
import orderReducer from "../slices/order";
import settingReducer from "../slices/setting";

const createRootReducer = (history) =>
  combineReducers({
    authReducer,
    chat: chatReducer,
    conversation: conversationReducer,
    order: orderReducer,
    setting: settingReducer,
    router: connectRouter(history),
  });

export default createRootReducer;
